import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {ForgetPasswordComponent} from './login/forget-password/forget-password.component';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {path: 'login', component: LoginComponent},
  {path: 'recover', component: ForgetPasswordComponent},

  {path: '**', redirectTo:"login"},
  // { path: "", redirectTo: '/login', pathMatch: 'full' },
  // { path: 'user/regions', component: DashboardComponent },
  // { path: "401", component: NeedAuthorizationComponent },
  // { path: "403", component: AccessDeniedComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
